import { useEffect, useRef, useState } from 'react';

export default function ValuesMarquee() {
  const host = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    let visible = false;
    const update = () => setActive(visible && !document.hidden);
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); });
    if (host.current) observer.observe(host.current);
    document.addEventListener('visibilitychange', update);
    return () => { observer.disconnect(); document.removeEventListener('visibilitychange', update); };
  }, []);
  return <div className="values-marquee" ref={host}>
    <div className="values-marquee-window" aria-hidden="true"><div className="values-marquee-track" style={{ animationPlayState: active ? 'running' : 'paused' }}>
      {[0, 1].map(copy => <div className="values-marquee-group" key={copy}><span>Innovation.</span><span>Automation.</span><span>Stability.</span></div>)}
    </div></div>
  </div>;
}
